import { Stack, Typography } from '@mui/material';
import {
  CompaniesCarousel,
  MacBookWindow,
  Section,
} from '@rumblefish/ui/Rumblefish23Theme';

export const Hero = () => {
  return (
    <>
      <MacBookWindow
        title={
          <>
            Boost your financial product
            <br />
            with state-of-the-art
            <br />
            technology
          </>
        }
        description={
          <>
            Custom fintech product development tailored to <b>your needs</b>
          </>
        }
        buttonText="Book a free consultation"
        buttonLink="/contact"
        gradient="purple-yellow"
      />

      <Section width="normal">
        <Stack
          sx={(theme) => ({
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(7),
            marginTop: theme.spacing(6),
            textAlign: 'center',
            marginBottom: theme.spacing(16),
            [theme.breakpoints.down('md')]: {
              marginBottom: theme.spacing(15),
            },
            [theme.breakpoints.down('sm')]: {
              marginBottom: theme.spacing(9),
            },
          })}>
          <Typography
            sx={{
              color: (theme) => theme.palette.invertedContent?.PRIMARY,
            }}
            variant="strong_400">
            If you’re looking for a reliable, trusted, and experienced team to
            build your fintech solution, you’ve come to the right place!
            <br />
            Our engineers have extensive experience in fintech software
            development and use battle-tested tools to bring your financial
            product to the next level.
            <br />
            We’re well aware of how important security and privacy are when it
            comes to fintech products - no matter if you’re building a crypto
            exchange, a digital wallet, or a money transfer platform.
          </Typography>
          <CompaniesCarousel />
        </Stack>
      </Section>
    </>
  );
};
